import { EDocumentType } from '../enums/document-type.enum';

export const EDocumentTypeOptions = [
    { value: EDocumentType.CPF, label: 'CPF' },
    { value: EDocumentType.CNPJ, label: 'CNPJ' },
];
